import React, { useEffect, useState } from "react";
import UploadImage from "../../shared/UploadImage";
import uploadImg from "../../../assets/img/upload/gallery-import.svg";
import uploadImgOrange from "../../../assets/img/upload/gallery-import-orange.svg";
import Button from "../../shared/Button";
import { useCreatePlace } from "../../../context/CreatePlaceContext";
import MultipleImageFile from "../../shared/MultipleImageFile";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";

const CreateStep9 = ({ prevStep,nextStep, }) => {
  const { updatePlaceDetail, createInfoData,apiUpdateResideces ,setIsEditPlaceCompleter} = useCreatePlace();
  const {id} =useParams()

  const [thumbnail, setthumbnail] = useState(
    createInfoData.stepFourteen.thumbnail
  );
 const [medialist, setmedialist] = useState(
   []
 );
 const [EditMediaList, setEditMediaList] = useState(
   []
);
 useEffect(() => {
  setthumbnail(createInfoData.stepFourteen.thumbnail)
  
  if(id){
    setEditMediaList(createInfoData.stepFourteen.newMedia)
    setmedialist(createInfoData.stepFourteen.media)

  }else{
    setmedialist(createInfoData.stepFourteen.media)
  }
 }, [
  createInfoData
 ])
 
  const gotonext = () => {

    if(thumbnail === null){
      toast.error("بارگزاری عکس اقامتگاه اجباری است")
    }else if((medialist.length + EditMediaList.length) < 5){
      toast.error("تعداد تصاویر اقامتگاه باید حداقل ۵ تا باشد.")
    }else if (id){
      updatePlaceDetail("stepFourteen", {
        thumbnail: thumbnail,
      media:medialist,
      newMedia:EditMediaList
      });
      nextStep()
    }else{
      updatePlaceDetail("stepFourteen", {
        thumbnail: thumbnail,
       media:medialist
      });
      nextStep()
    }
   
  };

  const update = (data) => {
    if(thumbnail === null){
      toast.error("بارگزاری عکس اقامتگاه اجباری است")
    }else if((medialist.length + EditMediaList.length) < 5){
      toast.error("تعداد تصاویر اقامتگاه باید حداقل ۵ تا باشد.")
    }else if (id){
      updatePlaceDetail("stepFourteen", {
        thumbnail: thumbnail,
      media:medialist,
      newMedia:EditMediaList
      });
      nextStep()
    }else{
      updatePlaceDetail("stepFourteen", {
        thumbnail: thumbnail,
       media:medialist
      });
       setIsEditPlaceCompleter(true);
    
      }
  };
  return (
    <div className="createsteps">
      <h2>تصاویر اقامتگاه</h2>
      <p>
        تصاویر اقامتگاه شما مخصوصا ۵ عکس اول مهم ترین و اول ترین نقطه برخورد
        مهمان با اقامتگاه شماست ، سعی کنید از عکس های با کیفیت بالا برای جذب
        مهمان به اقامتگاه خود ، استفاده کنید{" "}
      </p>
      <h4 className="mt-[50px] text-[#292D32] text-[24px] text-[700]">
        تصویر نمایه اقامتگاه{" "}
      </h4>
      <p className="mt-[8px] mb-[32px] text-[18px]">
        تصویر نمایه اولین تصویر از اقامتگاه است که در صفحات سایت دیده می شود ،
        این تصویر معرف اقامتگاه شما خواهد بود و کیفیت و زیبایی آن مشخص می کند
        مهمان از بین سایر اقامتگاه ها ، اقامتگاه شما را انتخاب می کند یا نه
      </p>
      <UploadImage
        id="1"
        file={thumbnail}
        setfile={setthumbnail}
        text="آپلود تصویر"
        uploadImg={uploadImg}
      />
      <h4 className="mt-[50px] text-[#292D32] text-[24px] text-[700]">
        تصویر نمایه اقامتگاه{" "}
      </h4>
      <p className="mt-[8px] mb-[32px] text-[18px]">
        تصویر نمایه اولین تصویر از اقامتگاه است که در صفحات سایت دیده می شود ،
        این تصویر معرف اقامتگاه شما خواهد بود و کیفیت و زیبایی آن مشخص می کند
        مهمان از بین سایر اقامتگاه ها ، اقامتگاه شما را انتخاب می کند یا نه
      </p>
      {/* */}
      {/* <UploadImage
        id="2"
        file={medialist}
        setfile={setmedialist}
        multiple = {true}
        text="آپلود تصاویر"
        orange
        uploadImg={uploadImgOrange}
      /> */}
      <MultipleImageFile
        fileid="2"
        file={medialist}
        setfile={setmedialist}
        multiple = {true}
        text="آپلود تصاویر"
        orange
        uploadImg={uploadImgOrange}
        edit={true}
        editfile={EditMediaList}
        seteditfile={setEditMediaList}
      />
      <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
     { id &&<Button varient="primary" onClick={()=>update()}> 
                بروزرسانی اقامتگاه
              </Button>}
        <Button
          varient="gray"
          onClick={() => {
            prevStep();
          }}
        >
          مرحله قبلی
        </Button>

        <Button varient="primary" onClick={gotonext}>
          مرحله بعدی
        </Button>
      </div>
    </div>
  );
};

export default CreateStep9;
